@if (stateI) {
    <mat-icon
        [ngClass]="'status ' + stateI"
        aria-label="Severity" 
        matTooltip="Severity: {{ stateI }}"
    >
        {{ icon }}
    </mat-icon>
}